export default __webpack_public_path__ + "static/media/Highlord's Axe.b41e9a29.jpg";